import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '@shared/components/button/button.module';

import { CheckboxWrapperComponent } from './checkbox-wrapper.component';


import { DirectivesModule } from '@shared/directives/directives.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    DirectivesModule
  ],
  declarations: [
    CheckboxWrapperComponent
  ],
  exports: [
    CheckboxWrapperComponent
  ]
})

export class CheckboxWrapperModule { }


